var _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagAustralia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 9,
    viewBox: "0 0 19 9",
    width: 19,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.5 0h10v5h-10z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.5 0h18v9h-18z",
    fill: "#0071cb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.275 4.725 10.45-4.95",
    mask: "url(#a)",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 1.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.25 4.75 10.5-5",
    mask: "url(#a)",
    stroke: "#ff7b7b",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.275 4.725 10.45-4.95",
    mask: "url(#a)",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 1.05,
    transform: "matrix(-1 0 0 1 11 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.25 4.75 10.5-5",
    mask: "url(#a)",
    stroke: "#ff7b7b",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5,
    transform: "matrix(-1 0 0 1 11 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.5 1.5h10v1h-10z",
    fill: "#fff",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.5 2.5h10v1h-10z",
    fill: "#fff",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.5 0h1v5h-1z",
    fill: "#fff",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.5 0h1v5h-1z",
    fill: "#fff",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 0h1v5h-1z",
    fill: "#ff7b7b",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.5 2h10v1h-10z",
    fill: "#ff7b7b",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.50068605 6-.20234432.61376777-.60266186-.22992452.35746908.55432426-.55314895.33128563.64035518.06229423-.08702982.65815466.45012447-.48271501.44528295.49281298-.09653645-.66807195.64780367-.05980487-.55446224-.33795069.36715213-.56123023-.61397182.2375532z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.2505145 2.5-.1517582.46032583-.4519964-.17244339.2681018.41574319-.4148617.24846423.4802664.04672067-.0652724.49361599.3375934-.36203625.3339622.36960973-.0724024-.50105396.4858528-.04485365-.4158467-.25346302.2753641-.42092267-.4604788.1781649z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.7505145.5-.1517582.46032583-.4519964-.17244339.2681018.41574319-.4148617.24846423.4802664.04672067-.0652724.49361599.3375934-.36203625.3339622.36960973-.0724024-.50105396.4858528-.04485365-.4158467-.25346302.2753641-.42092267-.4604788.1781649z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.7505145 2-.1517582.46032583-.4519964-.17244339.2681018.41574319-.4148617.24846423.4802664.04672067-.0652724.49361599.3375934-.36203625.3339622.36960973-.0724024-.50105396.4858528-.04485365-.4158467-.25346302.2753641-.42092267-.4604788.1781649z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.2505145 6-.1517582.46032583-.4519964-.17244339.2681018.41574319-.4148617.24846423.4802664.04672067-.0652724.49361599.3375934-.36203625.3339622.36960973-.0724024-.50105396.4858528-.04485365-.4158467-.25346302.2753641-.42092267-.4604788.1781649z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 4.75-.2938926.1545085.0561285-.32725425-.2377642-.23176275.328582-.04774575.1469463-.29774575.1469463.29774575.328582.04774575-.2377642.23176275.0561285.32725425z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagAustralia);
export default __webpack_public_path__ + "static/media/flag-australia.b3e6ac4e538643a8b809115d1faca4bd.svg";
export { ForwardRef as ReactComponent };